import { transition, trigger, useAnimation } from '@angular/animations';
import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  fadeInFromRightAnimation,
  fadeOutToRightAnimation,
} from '../../../../shared/animations/index';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'authenticate',
  standalone: false,
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInFromRightOutToRightAnimation', [
      transition(':enter', [
        useAnimation(fadeInFromRightAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutToRightAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class AuthenticateComponent implements OnInit, OnDestroy {
  private readonly _authenticationService = inject(AuthenticationService);
  private readonly _formBuilder = inject(FormBuilder);

  subscriptions: Subscription = new Subscription();

  loginForm: FormGroup;

  loginFormErrorMessage: string = null;
  loginActionInProgress: boolean = false;

  ngOnInit(): void {
    this.subscriptions.add(
      this._authenticationService
        .getIsLoggingIn$()
        .subscribe((state: boolean) => {
          this.loginActionInProgress = state;
        }),
    );

    this.subscriptions.add(
      this._authenticationService
        .getLoginFailed$()
        .subscribe((error: string) => {
          this.loginFormErrorMessage = error;
        }),
    );

    this.initializeLoginForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initializeLoginForm(): void {
    this.loginForm = this._formBuilder.group({
      password: ['', Validators.required],
      username: ['', Validators.required],
    });
  }

  onLoginFormSubmit(): void {
    this.loginFormErrorMessage = null;

    this._authenticationService.requestLogin({
      email: this.loginForm.controls.username.value,
      password: this.loginForm.controls.password.value,
    });

    this.loginForm.controls.password.reset();
  }
}
